import {AddressField} from './address-field';
import {BusinessCategoriesField} from './business-categories-field';
import {CapitalField} from './capital-field';
import {CategoriesField} from './categories-field';
import {CorporateNameField} from './corporate-name-field';
import {CorporateNameKanaField} from './corporate-name-kana-field';
import {EmployeesField} from './employees-field';
import {FoundationField} from './foundation-field';
import {IndustryKbnField} from './industry-kbn-field';
import {IpoKbnField} from './ipo-kbn-field';
import {PhoneNumberField} from './phone-number-field';
import {PresidentNameField} from './president-name-field';
import {PresidentTitleField} from './president-title-field';
import {SecurityCodeField} from './security-code-field';
import {WebsiteUrlField} from './website-url-field';

export const companyInfoFields = {
  addressField: AddressField,
  businessCategoriesField: BusinessCategoriesField,
  capitalField: CapitalField,
  categoriesField: CategoriesField,
  corporateNameField: CorporateNameField,
  corporateNameKanaField: CorporateNameKanaField,
  employeesField: EmployeesField,
  foundationField: FoundationField,
  industryKbnField: IndustryKbnField,
  ipoKbnField: IpoKbnField,
  phoneNumberField: PhoneNumberField,
  presidentNameField: PresidentNameField,
  presidentTitleField: PresidentTitleField,
  securityCodeField: SecurityCodeField,
  websiteUrlField: WebsiteUrlField,
};
